module.exports = __webpack_public_path__ + "static/media/screen1.52c2f94f.png";